module.exports = __webpack_public_path__ + "static/media/pic4.82b1eb3f.jpg";